(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-responsive-nav"] && !Shopify.designMode) return;
  try {
    
class AdvancedHoverNavigator {
  constructor(container) {
    this.container = container;
    this.pagesWrapper = this.container.querySelector('.advanced-hover-navigator__pages-wrapper');
    this.textContainersMobile = this.container.querySelectorAll('.mobile-text-wrapper .mobile-text');
    this.paginationDots = this.container.querySelectorAll('.mobile-pagination__dot');
    this.autoplayEnabled = this.container.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed, 10) * 1000;
    
    this.autoplayInterval = null;
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.diffX = 0;

    const pageCount = this.container.querySelectorAll('.advanced-hover-navigator__page').length;
    if (pageCount <= 1) return;

    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    this.init();
    this.container.sliderInstance = this;
  }

  isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  init() {
    if (this.isMobile()) {
      this.initMobile();
    } else {
      this.initDesktop();
    }
  }

  initDesktop() {
    const textLinks = this.container.querySelectorAll('.navigator-text__item-link');
    this.container.querySelector('.advanced-hover-navigator__page').classList.add('is-active');

    textLinks.forEach(link => {
      const index = parseInt(link.dataset.targetIndex, 10);
      link.addEventListener('mouseenter', () => this.activateItemDesktop(index));
      link.addEventListener('focus', () => this.activateItemDesktop(index));
    });
    this.container.addEventListener('mouseleave', () => this.activateItemDesktop(0));
    
    this.pagesWrapper.removeEventListener('touchstart', this.handleTouchStart);
    this.pagesWrapper.removeEventListener('touchmove', this.handleTouchMove);
    this.pagesWrapper.removeEventListener('touchend', this.handleTouchEnd);

    this.activateItemDesktop(0);
    this.stopAutoplay();
  }

  initMobile() {
    this.paginationDots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.dataset.index, 10);
        this.stopAutoplay();
        this.activateItemMobile(index);
        this.startAutoplay();
      });
    });

    this.pagesWrapper.addEventListener('touchstart', this.handleTouchStart);
    this.pagesWrapper.addEventListener('touchmove', this.handleTouchMove);
    this.pagesWrapper.addEventListener('touchend', this.handleTouchEnd);

    this.activateItemMobile(0);
    this.startAutoplay();
  }

  handleTouchStart(e) {
    if (!e.touches || e.touches.length === 0) return;
    this.isDragging = true;
    this.startX = e.touches[0].clientX;
    this.stopAutoplay();
    this.pagesWrapper.style.transition = 'none';
  }

  handleTouchMove(e) {
    if (!this.isDragging || !e.touches || e.touches.length === 0) return;
    this.currentX = e.touches[0].clientX;
    this.diffX = this.currentX - this.startX;
    const baseOffset = -this.currentIndex * this.container.offsetWidth;
    this.pagesWrapper.style.transform = `translateX(${baseOffset + this.diffX}px)`;
  }

  handleTouchEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.pagesWrapper.style.transition = '';

    const swipeThreshold = 50;
    let newIndex = this.currentIndex;
    const pageCount = this.textContainersMobile.length;

    if (this.diffX < -swipeThreshold) {
      newIndex = Math.min(this.currentIndex + 1, pageCount - 1);
    } else if (this.diffX > swipeThreshold) {
      newIndex = Math.max(this.currentIndex - 1, 0);
    }
    
    this.activateItemMobile(newIndex);
    this.startAutoplay();
    this.diffX = 0;
  }

  startAutoplay() {
    const pageCount = this.textContainersMobile.length;
    if (!this.isMobile() || !this.autoplayEnabled || pageCount <= 1) return;
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % pageCount;
      this.activateItemMobile(nextIndex);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    clearInterval(this.autoplayInterval);
    this.autoplayInterval = null;
  }

  activateItemDesktop(index) {
    const pages = this.container.querySelectorAll('.advanced-hover-navigator__page');
    const textLinks = this.container.querySelectorAll('.navigator-text__item-link');
    
    if (index === this.currentIndex && this.container.classList.contains('js-desktop-active')) return;
    this.currentIndex = index;
    
    pages.forEach((page, i) => page.classList.toggle('is-active', i === index));
    textLinks.forEach((link, i) => {
      link.querySelector('.navigator-text__item').classList.toggle('is-hover-active', i === index);
    });

    this.container.classList.add('js-desktop-active');
  }

  activateItemMobile(newIndex) {
    const pageCount = this.textContainersMobile.length;
    if (newIndex >= pageCount || newIndex < 0) return;
    this.currentIndex = newIndex;

    const offset = -newIndex * 100;
    this.pagesWrapper.style.transform = `translateX(${offset}%)`;

    this.textContainersMobile.forEach((text, i) => text.classList.toggle('is-active', i === newIndex));
    this.paginationDots.forEach((dot, i) => dot.classList.toggle('is-active', i === newIndex));
    
    this.container.classList.remove('js-desktop-active');
  }
}

function initializeNavigators(event) {
  const scope = event ? event.target : document;
  const navigators = scope.querySelectorAll('.advanced-hover-navigator');
  navigators.forEach(navigator => {
    if (!navigator.classList.contains('js-initialized')) {
      new AdvancedHoverNavigator(navigator);
      navigator.classList.add('js-initialized');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initializeNavigators());
document.addEventListener('shopify:section:load', (e) => initializeNavigators(e));
document.addEventListener('shopify:section:select', (e) => initializeNavigators(e));

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.querySelectorAll('.advanced-hover-navigator.js-initialized').forEach(nav => {
      const instance = nav.sliderInstance;
      if (instance) {
        instance.stopAutoplay();
        instance.init();
      }
    });
  }, 250);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(el) {
      this.component = el;
      this.el = this.component.querySelector('.hero-slider');
      this.slidesContainer = this.el.querySelector('.hero-slider__slides');
      this.originalSlides = Array.from(this.slidesContainer.children);
      this.dotsContainer = this.component.querySelector('.hero-slider__dots');
      
      this.mobileContentWrapper = this.component.querySelector('.hero-slider__mobile-content-wrapper');
      this.mobileContents = this.mobileContentWrapper ? Array.from(this.mobileContentWrapper.querySelectorAll('.hero-slider__mobile-content')) : [];

      this.slideCount = this.originalSlides.length;
      if (this.slideCount <= 1) {
        if (this.slideCount === 1) {
            this.originalSlides[0].classList.add('is-active');
            if (this.mobileContents.length > 0) this.mobileContents[0].classList.add('is-active');
        }
        return;
      }

      this.currentIndex = 1;
      this.autoplay = this.el.dataset.autoplay === 'true';
      this.speed = parseInt(this.el.dataset.speed, 10);
      this.timer = null;
      this.isTransitioning = false;

      // --- 新增: 滑动相关属性 ---
      this.isDragging = false;
      this.startX = 0;
      this.diffX = 0;

      this.init();
    }

    init() {
      this.cloneSlides();
      this.slides = Array.from(this.slidesContainer.children);
      
      // --- 新增: 绑定滑动事件 ---
      this.bindTouchEvents();

      this.createDots();
      this.addEventListeners();
      this.update(false);

      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    cloneSlides() {
      const firstClone = this.originalSlides[0].cloneNode(true);
      const lastClone = this.originalSlides[this.slideCount - 1].cloneNode(true);
      firstClone.classList.add('is-clone');
      lastClone.classList.add('is-clone');
      this.slidesContainer.appendChild(firstClone);
      this.slidesContainer.prepend(lastClone);
    }
    
    // --- 新增: 绑定事件处理函数 ---
    bindTouchEvents() {
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
    }

    addEventListeners() {
      if (this.dots) {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            if (this.isTransitioning) return;
            this.goToSlide(index + 1);
          });
        });
      }

      // --- 新增: 添加滑动事件监听器 ---
      this.slidesContainer.addEventListener('touchstart', this.handleTouchStart);
      this.slidesContainer.addEventListener('touchmove', this.handleTouchMove);
      this.slidesContainer.addEventListener('touchend', this.handleTouchEnd);

      this.slidesContainer.addEventListener('transitionend', () => {
        this.isTransitioning = false;
        this.handleLoop();
      });

      window.addEventListener('resize', this.debounce(() => this.update(false)));
    }

    // --- 新增: 触摸开始事件处理 ---
    handleTouchStart(e) {
      if (this.isTransitioning) return;
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.slidesContainer.style.transition = 'none'; // 拖动时移除过渡
      if (this.autoplay) {
        clearInterval(this.timer); // 暂停自动播放
      }
    }

    // --- 新增: 触摸移动事件处理 ---
    handleTouchMove(e) {
      if (!this.isDragging) return;
      const currentX = e.touches[0].clientX;
      this.diffX = currentX - this.startX;
      
      const activeSlide = this.slides[this.currentIndex];
      const baseOffset = (this.el.offsetWidth / 2) - (activeSlide.offsetWidth / 2) - activeSlide.offsetLeft;
      this.slidesContainer.style.transform = `translateX(${baseOffset + this.diffX}px)`;
    }

    // --- 新增: 触摸结束事件处理 ---
    handleTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      
      const swipeThreshold = 50; // 定义滑动阈值
      if (Math.abs(this.diffX) > swipeThreshold) {
        if (this.diffX < 0) {
          // 向左滑
          this.goToSlide(this.currentIndex + 1);
        } else {
          // 向右滑
          this.goToSlide(this.currentIndex - 1);
        }
      } else {
        // 未超过阈值，弹回原位
        this.update();
      }

      this.diffX = 0; // 重置滑动距离
      this.resetAutoplay(); // 重新开始自动播放
    }

    handleLoop() {
      if (this.currentIndex === 0) {
        this.currentIndex = this.slideCount;
        this.update(false);
      } else if (this.currentIndex === this.slideCount + 1) {
        this.currentIndex = 1;
        this.update(false);
      }
    }

    createDots() {
       if (!this.dotsContainer) return;
       this.dotsContainer.innerHTML = '';
       for (let i = 0; i < this.slideCount; i++) {
        const dot = document.createElement('button');
        dot.classList.add('hero-slider__dot');
        this.dotsContainer.appendChild(dot);
      }
      this.dots = Array.from(this.dotsContainer.children);
    }

    goToSlide(index, manual = true) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.currentIndex = index;
      this.update();

      if (manual && this.autoplay) {
          this.resetAutoplay();
      }
    }

    update(withTransition = true) {
      if (!withTransition) {
        this.slidesContainer.style.transition = 'none';
      } else {
        this.slidesContainer.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      }

      if (this.slides.length > 0) {
        const activeSlide = this.slides[this.currentIndex];

        const offset = (this.el.offsetWidth / 2) - (activeSlide.offsetWidth / 2) - activeSlide.offsetLeft;
        this.slidesContainer.style.transform = `translateX(${offset}px)`;

        this.slides.forEach((slide) => slide.classList.remove('is-active'));
        this.slides[this.currentIndex].classList.add('is-active');

        let activeDotIndex = this.currentIndex - 1;
        if (this.currentIndex === 0) activeDotIndex = this.slideCount - 1;
        if (this.currentIndex === this.slideCount + 1) activeDotIndex = 0;

        if (this.dots) {
          this.dots.forEach((dot, index) => {
            dot.classList.toggle('hero-slider__dot--active', index === activeDotIndex);
          });
        }
        
        if (this.mobileContents.length > 0) {
          this.mobileContents.forEach((content, index) => {
            content.classList.toggle('is-active', index === activeDotIndex);
          });
        }
      }

      if (!withTransition) {
        this.slidesContainer.offsetHeight; 
      }
    }

    startAutoplay() {
      this.timer = setInterval(() => {
        this.goToSlide(this.currentIndex + 1, false);
      }, this.speed);
    }

    resetAutoplay() {
        if(this.autoplay) {
            clearInterval(this.timer);
            this.startAutoplay();
        }
    }

    debounce(func, wait = 250) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  }

  const initHeroSliders = () => {
    document.querySelectorAll('.hero-slider-component').forEach(sliderComponent => {
      // 防止重复初始化
      if (!sliderComponent.classList.contains('js-hero-slider-initialized')) {
        new HeroSlider(sliderComponent);
        sliderComponent.classList.add('js-hero-slider-initialized');
      }
    });
  }

  // 修改事件监听逻辑，确保在编辑器中也能正确重载
  const setupEventListeners = () => {
    initHeroSliders();
    document.addEventListener('shopify:section:load', initHeroSliders);
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEventListeners);
  } else {
    setupEventListeners();
  }


  } catch(e) { console.error(e); }
})();
})();
